import { render, staticRenderFns } from "./QuickSearchMaterial.vue?vue&type=template&id=ddf34e0c"
import script from "./QuickSearchMaterial.vue?vue&type=script&lang=js"
export * from "./QuickSearchMaterial.vue?vue&type=script&lang=js"
import style0 from "./QuickSearchMaterial.vue?vue&type=style&index=0&id=ddf34e0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports